<template>
  <div>
    <br />
    The <b> Results error</b> panel displays approximate errors for several
    metrics. These errors are interpolated from internal validation data, for
    similar results.
    <br />
    <br />
    As validation results are currently restricted to a limited number of cases
    (c.f. technical documentation), some maneuvers may not be associated with
    errors estimates, as the results could not be compared to the validation
    set. A message explaining the reason of the missing error will be displayed
    to the user in teh "Error comments" section.
  </div>
</template>

<script>
export default {
  name: 'tooltipResultsError'
}
</script>
